import React from 'react';
import TooltipEditOverlay from './TooltipEditOverlay';
import PencilSVG from '../svg/PencilSVG';
import TooltipDto from './types/TooltipDto';
import { EntityDefinition } from 'types';

/**
 * Tooltip edit button component props
 */
interface TooltipEditButtonProps {
	name: string;
	label: string;
	tooltipData: { [name: string]: { fieldTooltip: TooltipDto; universalTooltip: TooltipDto } };
	entityDefinition: EntityDefinition;
}

/**
 * Tooltip edit button component state
 */
interface TooltipEditButtonState {
	isOpen: boolean;
}

/**
 * Tooltip edit button component
 * Displayed in the edit form field labels if the AppState.user.isTooltipEditMode is on.
 * Clicking on this will open the TooltipEditOverlay popover
 * where the tooltip data for the current field can be edited.
 */
export class TooltipEditButton extends React.PureComponent<TooltipEditButtonProps, TooltipEditButtonState> {
	constructor(props) {
		super(props);

		this.state = { isOpen: false };
	}

	private toggle = () => {
		this.setState((prevState) => {
			return { isOpen: !prevState.isOpen };
		});
	};

	public render() {
		return (
			<>
				<button type="button" className="tooltip__edit-btn" onClick={this.toggle}>
					<span className="tooltip__edit-wrapper">
						<PencilSVG class="tooltip__edit-icon" />
					</span>
				</button>
				<TooltipEditOverlay
					name={this.props.name}
					label={this.props.label}
					isOpen={this.state.isOpen}
					toggle={this.toggle}
					tooltipData={this.props.tooltipData}
					entityDefinition={this.props.entityDefinition}
				/>
			</>
		);
	}
}
